import {
  getAankomstTijdTooltipText,
  getVertrektijdTooltipText,
} from '@/apps/mwd-v2/components/MwdTooltip/MwdTooltipContent';
import { Overgang } from '@/types/deeltrajecten';

import styles from './MwdTooltip.module.css';

const calculateOvergangsTijd = (overgang: Overgang) => {
  if (overgang.aankomstTijdVoorgaandeInzet && overgang.vertrekTijdVolgendeInzet) {
    const diff = (overgang.vertrekTijdVolgendeInzet.getTime() - overgang.aankomstTijdVoorgaandeInzet.getTime()) / 60000;
    if (diff < 0) return 0;
    const uren = Math.floor(diff / 60);
    const minuten = Math.round(diff % 60);
    if (uren > 0 && minuten > 0) return ` (${uren} uur en ${minuten} min)`;
    if (uren > 0) return ` (${uren} uur)`;
    return ` (${minuten} min)`;
  }
  return null;
};

const MwdOvergangTooltipContent = ({ data }: { data: Overgang }) => {
  return (
    <div data-testid='mwd-overgang-tooltip' className={styles.mwdTooltipStyleV2}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <span style={{ marginBottom: '4px' }}>
          <strong>{data.dienstregelpunt}</strong>
          <span>{calculateOvergangsTijd(data)}</span>
        </span>
        {getAankomstTijdTooltipText(
          undefined,
          data.aankomstOorsponkelijkeTijdVoorgaandeInzet || new Date(),
          data.actueleAankomstTijdVoorgaandeInzet || new Date(),
          data.aankomstTijdVoorgaandeInzet || new Date(),
          true,
        )}
        {getVertrektijdTooltipText(
          data.vertrekOorsponkelijkeTijdVolgendeInzet || new Date(),
          data.actueleVertrekTijdVolgendeInzet || new Date(),
          data.vertrekTijdVolgendeInzet || new Date(),
          undefined,
          undefined,
          true,
        )}
      </div>
    </div>
  );
};

export default MwdOvergangTooltipContent;
